/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

export const CardContext = createContext( {} );
export const useCardContext = () => useContext( CardContext );
